import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import EmptyDataSvg from '@common/assets/icons/empty-data.svg';

import {
	StyledEmptyDataContainer,
	StyledEmptyDataImageWrap,
	StyledEmptyDataSubTitle,
	StyledEmptyDataTitle,
	StyledEmptyDataWrap,
} from './styled';

export interface EmptyDataProps {
	title?: string;
	subTitle?: string;
	icon?: ReactNode;
	children?: ReactNode;
}

function EmptyData({ title, subTitle, icon, children }: EmptyDataProps) {
	const { t } = useTranslation();
	return (
		<StyledEmptyDataContainer>
			<StyledEmptyDataWrap>
				<StyledEmptyDataImageWrap>{icon || <EmptyDataSvg />}</StyledEmptyDataImageWrap>
				<StyledEmptyDataTitle variant="h2">
					{title || t('shared.emptyDataTitle')}
				</StyledEmptyDataTitle>
				{subTitle && <StyledEmptyDataSubTitle>{subTitle}</StyledEmptyDataSubTitle>}
				{children}
			</StyledEmptyDataWrap>
		</StyledEmptyDataContainer>
	);
}

export default EmptyData;
